<template>
<div>
    <div class="d-flex flex-column-fluid">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="row">
                        <div class="col-lg-12 col-xl-12">
                            <div class="card card-custom gutter-b bg-transparent shadow-none border-0">
                                <div class="card-header align-items-center border-bottom-dark px-0">
                                    <div class="card-title mb-0">
                                        <h3 class="card-label mb-0 font-weight-bold text-body">
                                            Add Discount
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-lg-12 col-xl-12">
                            <div class="card card-custom gutter-b bg-white border-0">
                                <div class="card-body">
                                    <!-- Brand Selection -->
                                    <div class="col-md-12">
                                        <label class="text-body">Brand</label>
                                        <fieldset class="form-group mb-3">
                                            <select v-model="brand_id" @change="fetchCategories" class="form-control">
                                                <option value="">Select Brand</option>
                                                <option v-for="brand in brands" :value="brand.brand_id">{{ brand.brand_name	 }}</option>
                                            </select>
                                        </fieldset>
                                    </div>

                                    <!-- Category Selection -->
                                    <div class="col-md-12" v-if="categories.length > 0">
                                        <label class="text-body">Category</label>
                                        <fieldset class="form-group mb-3">
                                            <select v-model="category_id" @change="fetchProducts" class="form-control">
                                                <option value="">Select Category</option>
                                                <option v-for="category in categories" :value="category.id">{{ category.detail[0].name }}</option>
                                            </select>
                                        </fieldset>
                                    </div>

                                    <!-- Product Selection -->
                                   <div class="col-md-12" v-if="products.length > 0">
                                <label class="text-body">Products</label>
                                <fieldset class="form-group mb-3">
                                    <multiselect 
                                        v-model="selectedProducts"
                                        :options="products" 
                                        placeholder="Select Products" 
                                        :custom-label="productTitleLabel"
                                        track-by="id"
                                        :multiple="true"
                                    ></multiselect>
                                </fieldset>
                            </div>
                                    <!-- Discount Details -->
                                    <div class="col-md-12" v-if="selectedProducts.length > 0">
                                        <div class="form-group">
                                            <label class="text-body">Discount Name</label>
                                            <input type="text" v-model="discount.name" class="form-control">
                                        </div>

                                        <div class="form-group">
                                            <label class="text-body">Discount Type</label>
                                            <select v-model="discount.type" class="form-control">
                                                <option value="percentage">Percentage</option>
                                                <option value="fixed">Fixed Amount</option>
                                            </select>
                                        </div>

                                        <div class="form-group">
                                            <label class="text-body" v-if="discount.type === 'percentage'">Percentage (%)</label>
                                            <label class="text-body" v-else>Fixed Amount</label>
                                            <input type="number" 
                                                v-model="discount.value" 
                                                class="form-control"
                                                :min="discount.type === 'percentage' ? 0 : 0"
                                                :max="discount.type === 'percentage' ? 100 : null">
                                        </div>

                                        <div class="form-group">
                                            <label class="text-body">Start Date</label>
                                            <input type="date" v-model="discount.start_date" class="form-control">
                                        </div>

                                        <div class="form-group">
                                            <label class="text-body">End Date</label>
                                            <input type="date" v-model="discount.end_date" class="form-control">
                                        </div>

                                        <button class="btn btn-primary" @click="saveDiscount">Save Discount</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Multiselect from "vue-multiselect";
import ErrorHandling from "./../../ErrorHandling";

export default {
    components: { Multiselect },
    data() {
        return {
            brand_id: '',
            category_id: '',
            brands: [],
            categories: [],
            products: [],
            selectedProducts: [],
            discount: {
                name: '',
                type: 'percentage',
                value: 0,
                start_date: '',
                end_date: ''
            },
            token: {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            },
            errors: new ErrorHandling()
        };
    },
    mounted() {
        this.fetchBrands();
    },
    methods: {
        fetchBrands() {
            this.$parent.loading = true;
            axios.get('/api/admin/brand', this.token)
                .then(response => {
                    this.brands = response.data.data;
                })
                .finally(() => {
                    this.$parent.loading = false;
                });
        },
        fetchCategories() {
          //  if (!this.brand_id) return;
            
            this.$parent.loading = true;
            this.category_id = '';
            this.products = [];
            this.selectedProducts = [];
            
            axios.get(`/api/admin/brandCategory/${this.brand_id}`, this.token)
                .then(response => {
                    this.categories = response.data.data;
                })
                .finally(() => {
                    this.$parent.loading = false;
                });
        },
        fetchProducts() {
            if (!this.category_id) return;
            
            this.$parent.loading = true;
            this.products = [];
            this.selectedProducts = [];
            
            const params = {
                brand_id: this.brand_id,
                category_id: this.category_id
            };
            
            axios.get('/api/admin/discount-Product', { params, headers: this.token.headers })
                .then(response => {
                    this.products = response.data.data;
                })
                .finally(() => {
                    this.$parent.loading = false;
                });
        },
        productTitleLabel(product) {
        // Return the title from detail[0] if available, otherwise fallback to name or ID
        return product.detail?.[0]?.title || product.name || `Product #${product.id}`;
    },
        saveDiscount() {
            this.$parent.loading = true;
            
            const discountData = {
                ...this.discount,
                product_ids: this.selectedProducts.map(p => p.id),
                amount: this.discount.type === 'fixed' ? this.discount.value : null,
                percentage: this.discount.type === 'percentage' ? this.discount.value : null
            };
            
            axios.post('/api/admin/discounts', discountData, this.token)
                .then(response => {
                    this.$toaster.success('Discount created successfully');
                    this.$router.push('/admin/product-discount');
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        this.errors.record(error.response.data.errors);
                    } else {
                        this.$toaster.error(error.response.data.message);
                    }
                })
                .finally(() => {
                    this.$parent.loading = false;
                });
        }
    }
};
</script>